import React from "react";
import PropTypes from "prop-types";
import PasswordValidationSettings from "../../../entities/PasswordValidationSettings";

const PasswordRequirements = (props) => {
    const passwordRequirements = props.passwordRequirements;
    return (<div className="password-requirements">
        <span><b>Password Minimum Requirements</b></span>
        <ul>
            <li>{passwordRequirements.length.digits} or more characters</li>
            <li>{passwordRequirements.upperChars.digits} or more capital letters</li>
            <li>{passwordRequirements.lowerChars.digits} or more lowercase letters</li>
            <li>{passwordRequirements.numbers.digits} or more numbers</li>
            <li>{passwordRequirements.special.digits} or more special characters (!, $, #, etc)</li>
            <li>{passwordRequirements.maxConsecutiveChars.digits} or fewer consecutive name/email characters</li>
        </ul>
    </div>);
};

PasswordRequirements.propTypes = {
    passwordRequirements: PropTypes.instanceOf(PasswordValidationSettings)
};

export default PasswordRequirements;
